






























import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import ScrollView from '@/components/ScrollView.vue'
import { ITransactionToPay } from '@zunta/configurations'

@Component({
  components: {
    Icon,
    ScrollView
  }
})
export default class ReviewApplied extends Vue {
  get scheduleItemId () {
    return this.$route.params.scheduleItemId
  }

  get transactionsToApply () {
    return this.$store.state.payments.transactionsToApply
  }

  get totalAmount () {
    if (!this.transactionsToApply || !this.transactionsToApply.length) {
      return 0
    }
    return this.transactionsToApply
        .reduce((total: number, transaction: ITransactionToPay) =>
            total + parseFloat((transaction.amount as number).toFixed(2)), 0)
  }
}
